interface DraggedEvent {
  eventId: string
  /** How far below the event's top edge it was grabbed, in pixels */
  yOffset: number
}

/**
 * The event currently being dragged, if any.
 *
 * The browser only lets a drop target read the drag data
 * on drop, not while the event is dragged over it. The day
 * column needs the grab offset during the drag to show
 * where the event will land, so the event keeps it here.
 */
let draggedEvent: DraggedEvent | null = null

export function setDraggedEvent(event: DraggedEvent | null) {
  draggedEvent = event
}

export function getDraggedEvent() {
  return draggedEvent
}
